export default __webpack_public_path__ + "static/media/KL_Tree_128.png";